<template>
  <HeadTitle
    title="Reportes de Autogestión"
    description="Reportes generales disponibles de la plataforma"
  />
  <Divider />
  <div class="mt-3">
    <Button
      icon="pi pi-chart-line"
      label="Vacaciones"
      @click="router.push('/reports/vacations')"
      class="text-sm font-light bg-green-100 border-green-100 text-green-700 mr-3"
    />
  </div>
</template>
<script setup lang="ts">
  import HeadTitle from '@/shared/components/HeadTitle.vue'
  import router from '@/router'
</script>
